import { useLocation } from "react-router-dom";

const RentHeader = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const category = params.get("category");
  const building = params.get("building");

  // Convert slug to readable text
  const formatText = (text) =>
    text
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  let headingText = "Apartments & Houses For Rent";

  // Building takes precedence
  if (building === "true") {
    headingText = "All Rental Buildings";
  } 
  // Category comes next
  else if (category) {
    headingText = `${formatText(category)}s For Rent`;
  }

  return <h6 className="mb-0">{headingText}</h6>;
};

export default RentHeader;
